<app-header></app-header>

<bit-container>
  <h1 bitTypography="h1">Duplicate logins</h1>
  <p bitTypography="body1">
    Review personal login records grouped by the same website domain and username. Nothing is
    deleted automatically; selected records are moved to trash.
  </p>

  <div class="tw-flex tw-items-end tw-gap-3 tw-mb-6">
    <bit-form-field class="tw-flex-1 !tw-mb-0">
      <bit-label>Filter by website, username, or item name</bit-label>
      <input bitInput [(ngModel)]="filter" />
    </bit-form-field>
    <button bitButton buttonType="secondary" type="button" (click)="scan()" [disabled]="loading">
      Rescan
    </button>
  </div>

  @if (loading) {
    <p bitTypography="body1"><i class="bwi bwi-spinner bwi-spin" aria-hidden="true"></i> Loading</p>
  } @else if (groups.length === 0) {
    <bit-callout type="success" title="No duplicates found">
      No personal logins share the same normalized domain and username.
    </bit-callout>
  } @else {
    <div class="tw-flex tw-items-center tw-justify-between tw-mb-4">
      <p bitTypography="body1" class="tw-m-0">
        {{ groups.length }} duplicate group{{ groups.length === 1 ? "" : "s" }} found.
        {{ selectedCount }} selected.
      </p>
      <div class="tw-flex tw-gap-2">
        <button bitButton buttonType="secondary" type="button" (click)="clearSelection()">
          Clear selection
        </button>
        <button
          bitButton
          buttonType="danger"
          type="button"
          [disabled]="selectedCount === 0 || deleting"
          (click)="deleteSelected()"
        >
          Move selected to trash
        </button>
      </div>
    </div>

    @for (group of visibleGroups; track group.key) {
      <section class="tw-border tw-border-solid tw-border-secondary-300 tw-rounded tw-mb-6">
        <div class="tw-flex tw-items-center tw-justify-between tw-bg-secondary-100 tw-p-4">
          <div>
            <strong>{{ group.domain }}</strong>
            <span class="tw-text-muted"> — {{ group.username || "(empty username)" }}</span>
          </div>
          <button bitButton buttonType="secondary" type="button" (click)="selectAllButNewest(group)">
            Select all but newest
          </button>
        </div>
        <bit-table>
          <ng-template body>
            @for (row of group.rows; track row.cipher.id) {
              <tr bitRow>
                <td bitCell class="tw-w-12">
                  <input type="checkbox" bitCheckbox [(ngModel)]="row.selected" [attr.aria-label]="'Select ' + row.cipher.name" />
                </td>
                <td bitCell><strong>{{ row.cipher.name }}</strong></td>
                <td bitCell>{{ row.cipher.login.username || "(empty username)" }}</td>
                <td bitCell>{{ row.cipher.revisionDate | date: "medium" }}</td>
                <td bitCell>
                  Password {{ row.cipher.login.password ? "present" : "empty" }}
                  @if (row.cipher.notes) { · Notes present }
                </td>
              </tr>
            }
          </ng-template>
        </bit-table>
      </section>
    }
  }
</bit-container>
